import type { SelectProps } from 'antd';

/**
 * Builds the auto-selected value payload respecting the current mode and labelInValue.
 */
export const buildAutoSelectValue = (
  option: NonNullable<SelectProps['options']>[number],
  mode: SelectProps['mode'],
  labelInValue?: boolean
) => {
  const plain = option.value;
  const labeled = { value: option.value, label: option.label ?? option.value };

  const single = labelInValue ? labeled : plain;
  const isMultiMode = mode === 'multiple' || mode === 'tags';

  return isMultiMode ? [single] : single;
};

export const isValueSet = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') return false;
  if (Array.isArray(value)) return value.length > 0;
  return true;
};
